export const ProjectAdministrationColors = {
  borderColor: 'border-green-400',
  backgroundColor: 'bg-green-400',
  textColor: 'text-green-800',
};
